import React from "react";
import {PdfElementProps} from "./_models";
import {
    Text,
    StyleSheet,
} from "@react-pdf/renderer";

export function PdfH1Component({config}: PdfElementProps) {
    const style = StyleSheet.create({
        main: {
            ...{
                fontSize: '26pt',
                fontWeight: 'bold'
            },
            ...(config.style || {}),
        }
    })

    return (
        <Text style={style.main}>{config.content}</Text>
    )
}